import axios from "@lib/axios";
import { getCartById } from "@utils/call-api/carts-call";

export const TYPES = {
  OPEN_SALES_CART_MODAL: "OPEN_SALES_CART_MODAL",
  CLOSE_SALES_CART_MODAL: "CLOSE_SALES_CART_MODAL",
  SET_PENDING_SALES_CART: "SET_PENDING_SALES_CART",
  SET_USE_PURCHASE_CREDIT: "SET_USE_PURCHASE_CREDIT",
};

export function openCartModal() {
  return (dispatch) => {
    dispatch({ type: TYPES.OPEN_SALES_CART_MODAL });
  };
}

export function closeCartModal() {
  return (dispatch) => {
    dispatch({ type: TYPES.CLOSE_SALES_CART_MODAL });
  };
}

function setPendingCart(cart) {
  return {
    type: TYPES.SET_PENDING_SALES_CART,
    cart,
  };
}

function setUsePurchaseCredit(usePurchaseCredit) {
  return {
    type: TYPES.SET_USE_PURCHASE_CREDIT,
    usePurchaseCredit,
  };
}

export async function initializePendingCart(dispatch) {
  try {
    const res = await axios.get("carts");
    const cart = res.data.data;
    await dispatch(setPendingCart(cart));
    return cart;
  } catch (err) {
    return { cart: {} };
  }
}
export function getPendingCart(redeemName, usePurchaseCredit) {
  return async (dispatch) => {
    try {
      dispatch(setUsePurchaseCredit(usePurchaseCredit));

      const res = await axios.get("carts", { params: { redeem_name: redeemName, use_purchase_credits: usePurchaseCredit } });
      const cart = res.data.data;
      await dispatch(setPendingCart(cart));
      return cart;
    } catch (err) {
      return { cart: {} };
    }
  };
}

export function reloadPendingCart() {
  return async (dispatch, getState) => {
    try {
      const redeemName = getState().cart.pendingCart?.summary?.coupon?.name || null;
      const usePurchaseCredit = getState().cart?.usePurchaseCredit;

      const res = await axios.get("carts", { params: { redeem_name: redeemName, use_purchase_credits: usePurchaseCredit } });
      const cart = res.data.data;
      await dispatch(setPendingCart(cart));
      return cart;
    } catch (err) {
      return { cart: {} };
    }
  };
}

export function getInvoicingCart(cartId) {
  return async (dispatch) => {
    try {
      const cart = await getCartById(cartId);
      await dispatch(setPendingCart(cart));
      return cart;
    } catch (err) {
      return { cart: {} };
    }
  };
}

export function postCartItem(variantId) {
  return async (dispatch, getState) => {
    const redeemName = getState().cart.pendingCart?.summary?.coupon?.name || null;
    const usePurchaseCredit = getState().cart?.usePurchaseCredit;

    const res = await axios.post("cart_items", { variant_id: variantId, redeem_name: redeemName, use_purchase_credits: usePurchaseCredit });
    const cart = res.data.data;

    await dispatch(setPendingCart(cart));
    return cart;
  };
}

export function deleteCartItem(cartItemId) {
  return async (dispatch, getState) => {
    const redeemName = getState().cart.pendingCart?.summary?.coupon?.name || null;
    const usePurchaseCredit = getState().cart?.usePurchaseCredit;

    const res = await axios.delete(`cart_items/${cartItemId}`, { params: { redeem_name: redeemName, use_purchase_credits: usePurchaseCredit } });
    const cart = res.data.data;

    await dispatch(setPendingCart(cart));
    return cart;
  };
}

export async function putPayCart(cartId, redeemName, usePurchaseCredit) {
  try {
    const res = await axios.put(`carts/${cartId}?redeem_name=${redeemName}&use_purchase_credits=${usePurchaseCredit}`);
    return res.data.data;
  } catch (err) {
    throw err.response.data.data;
  }
}
